import React from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import { APP_ROUTES } from "./approutes";
import LoginPage from "../components/Authentication/login";
import Dashboard from "../components/Dashboard";
import ProfileScreen from "../components/ProfileScreen/profileSreen";
import ServicesList from "../components/serviceEnquiry/servicesList";
import FilterEnquiry from "../components/serviceEnquiry/filterEnquiry";
import ApproveEnquiry from "../components/serviceEnquiry/approvalEnquiry";
import FinanceApproval from "../components/serviceEnquiry/financeApproval";
import PracticeAdmin from "../components/practiceAdmin/practiceAdminList";
import PracticeAdminBillList from "../components/practiceAdmin/practiceAdminBilling";
import Downloads from "../components/serviceEnquiry/download";
import AgentReport from "../components/serviceEnquiry/agentReport";
import TraumaApproval from "../components/serviceEnquiry/traumaApproval";
import PropTypes from "prop-types";
import PatientFeedback from "../components/serviceEnquiry/patientFeeback";
import FeedbackReport from "../components/serviceEnquiry/patientFeedbackReport";
import EnquiryList from "../components/serviceEnquiry/enquiryList";

const PrivateRoute = ({ children, ...rest }) => {
  const isAuthenticated = checkIsLoggedIn();

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isAuthenticated ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: APP_ROUTES.LOGIN,
              state: { from: location }
            }}
          />
        )
      }
    />
  );
};
PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired
};
const checkIsLoggedIn = () => {
  const loginObjStr = localStorage.getItem('loginObj');

  if (!loginObjStr) {
    return false;
  }

  try {
    const loginObj = JSON.parse(loginObjStr);
    return !!loginObj?.userSession?.userCode;
  } catch (error) {
    console.error('Error parsing login object:', error);
    return false;
  }
};

const clearSession = () => {
  localStorage.clear();
  sessionStorage.clear();
  globalThis.location.href = "/";
};

const OurRoutes = () => {
  return (
    <Router>
      <Switch>
        <Route exact path={APP_ROUTES.LOGIN} component={LoginPage} />
        <Route exact path={APP_ROUTES.LOGIN1} component={LoginPage} />
        <Route exact path={APP_ROUTES.APPROVEENQ} component={ApproveEnquiry} />
        <Route exact path={APP_ROUTES.FINANCE} component={FinanceApproval} />
        <Route exact path={APP_ROUTES.TRAUMA} component={TraumaApproval} />
        <Route exact path={APP_ROUTES.FEEDP} component={PatientFeedback} />
        <Route exact path={APP_ROUTES.FEEDREPORT} component={FeedbackReport} />
        <PrivateRoute exact path={APP_ROUTES.DASHBOARD}>
          <Dashboard />
        </PrivateRoute>

        <PrivateRoute exact path={APP_ROUTES.ENQLIST}>
          <EnquiryList />
        </PrivateRoute>

        <PrivateRoute exact path={APP_ROUTES.PROFILESCREEN}>
          <ProfileScreen />
        </PrivateRoute>

        <PrivateRoute exact path={APP_ROUTES.FILTERENQ}>
          <FilterEnquiry />
        </PrivateRoute>

        <PrivateRoute exact path={APP_ROUTES.PRALIST}>
          <PracticeAdmin />
        </PrivateRoute>

        <PrivateRoute exact path={APP_ROUTES.SERVICE}>
          <ServicesList />
        </PrivateRoute>

        <PrivateRoute exact path={APP_ROUTES.BILLAPPROVE}>
          <PracticeAdminBillList />
        </PrivateRoute>

        <PrivateRoute exact path={APP_ROUTES.DOWNLOAD}>
          <Downloads />
        </PrivateRoute>

        <PrivateRoute exact path={APP_ROUTES.AGENT_REPORTS}>
          <AgentReport />
        </PrivateRoute>

        <Route path="*">
          <Redirect to={APP_ROUTES.LOGIN} />
        </Route>
      </Switch>
    </Router>
  );
};

export default OurRoutes;
